// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1s9W4","resendInfoText":"OnGoingPaymentBox_resendInfoText__2D0q2"};